export enum LeftNavType {
  Back = 'back',
  Dismiss = 'dismiss',
}
